import { FunctionComponent, memo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltRight } from "@fortawesome/pro-solid-svg-icons";
import { IProps } from "./metric-chart-values-range.types";
import "./metric-chart-values-range.scss";

/**
 * Display the formatted values selected by user
 * @param props.startValue
 * @param props.endValue
 * @param props.formatValue
 */
const MetricChartValuesRange: FunctionComponent<IProps> = ({
    startValue,
    endValue,
    formatValue,
    isBooleanRange = false,
}) => {
    // Order values
    const [firstValue, lastValue] = startValue < endValue ? [startValue, endValue] : [endValue, startValue];

    return (
        <div className="metric-chart-values-range">
            {isBooleanRange ? (
                startValue === endValue ? (
                    <div className="metric-chart-values-range__value">{formatValue(firstValue)}</div>
                ) : (
                    <>
                        <div className="metric-chart-values-range__value">{formatValue(firstValue)}</div>
                        &amp;
                        <div className="metric-chart-values-range__value">{formatValue(lastValue)}</div>
                    </>
                )
            ) : (
                <>
                    <div className="metric-chart-values-range__value">{formatValue(firstValue)}</div>
                    <FontAwesomeIcon icon={faLongArrowAltRight} />
                    <div className="metric-chart-values-range__value">{formatValue(lastValue)}</div>
                </>
            )}
        </div>
    );
};

export default memo(MetricChartValuesRange);
